// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Argentina from '../_raw/flag/icon_flag_argentina.png';

export default () => <img src={Argentina} alt="Argentina" />;
